<template>
  <div>
    <div class="text-h6 mt-2 mb-4">Générer un lien de paiement supplémentaire</div>
    <PaymentLinkGeneratorCreateForm :item="item" @onCreate="reload" :key="key_create"></PaymentLinkGeneratorCreateForm>
    <hr />
    <div class="text-h6 mt-2 mb-4">Lien de paiement envoyés pour cette inscription</div>
    <div v-if="list_requests.length == 0">Aucun lien de paiement envoyé pour cette inscription.</div>
    <div v-else>
      <div class="row">
        <div class="col col-md-2">
          <label class="field_label">Email</label>
        </div>
        <div class="col col-md-2">
          <label class="field_label">Montant</label>
        </div>
        <div class="col col-md-2">
          <label class="field_label">Envoyé le</label>
        </div>
        <div class="col col-md-2">
          <label class="field_label">Statut</label>
        </div>

        <div class="col col-md-2">
          <label class="field_label">Motif</label>
        </div>
      </div>
      <div class="row bordered align-center" v-for="(request, index_request) in list_requests" :key="index_request">
        <div class="col col-md-2">
          <div>{{ request.email }}</div>
        </div>
        <div class="col col-md-2">
          <div>{{ request.total }} €<br />{{ request.montant_sportif }}€ sportif, {{ request.montant_option }}€ option
          </div>
        </div>
        <div class="col col-md-2">
          <div>{{ $moment(request.timestamp).format("DD/MM/YYYY à HH:mm") }}</div>
        </div>
        <div class="col col-md-2">
          <div><v-chip color="primary-dark" size="small" v-if="request.status == 'pending'">En attente de
              paiement</v-chip> <v-chip color="dark-green" v-else>Payé</v-chip></div>
        </div>
        <div class="col col-md-2">
          <div>{{ request.motif }}</div>
        </div>
        <div class="col col-md-2">
          <a :href="'https://sportips.fr/inscription/' + mainStore.module.base + '/demande_paiement/?req=' + request.token"
            target="_blank">Lien</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";
import AdminService from "@/services/admin.service";
import PaymentLinkGeneratorCreateForm from "./PaymentLinkGeneratorCreateForm.vue";
export default {
  name: "PaymentLinkGenerator",
  components: { PaymentLinkGeneratorCreateForm },
  props: ["item"],
  data() {
    return {
      list_requests: [],
      key_create: 0,
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    async reload() {
      this.key_create++;
      await this.fetch_list_requests();
    },
    async fetch_list_requests() {
      this.list_requests = await AdminService.getPaymentsRequests(this.item);

    },
  },
  async mounted() {
    await this.fetch_list_requests();
  },
};
</script>

<style lang="scss" scoped></style>